var PaeFactory = function ($resource, $window) {
    var getCheckPaeUserApi = "/participant-web-services/rest/sso/isPAEUser";
    var checkPaeUserParams = {
        individualId: "@individualId",
        groupId: "@groupId"
    };

    return {
        //This tells whether the user is a PAE user or not.
        getCheckPaeUser: $resource(__baseApiUrl__ + getCheckPaeUserApi, checkPaeUserParams, {
            query: {
                method: "GET",
                isArray: false,
                headers: {
                    "Content-Type": "application/json"
                }
            }
        })
    };
};

PaeFactory.$inject = ["$resource", "$window"];
export default PaeFactory;
